import { logger } from '@fiverr-private/obs';

/**
 * Logs error via window function or obs logger.
 * @param {String} domain - package or file
 * @param {String} title - function or error title
 * @param {String} message - custom error message
 * @param {Error} error - error (used for obs logging only)
 */
const error = (domain, title, message, error) => {
    if (typeof Fiverr === 'object' && typeof Fiverr._logErrorToServer === 'function') {
        Fiverr._logErrorToServer(domain, title, message);
    } else {
        logger.error(error, { domain, title, message });
    }
};

export {
    error
};
